<template>
  <BaseDialog
    type="basic"
    title="Dialog-Themen bearbeiten"
    :is-open="isOpen"
    class="md:w-[600px]"
    @close="emits('close')"
  >
    <LoadingWrapper :state="topicsStatus">
      <ul class="flex flex-col gap-1">
        <li v-for="feedbackTopic in selectableFeedbackTopics" :key="feedbackTopic.id">
          <BaseCheckboxListItem
            :icon="feedbackTopic.icon"
            :title="feedbackTopic.title"
            :selected="selectedFeedbackTopicIds.includes(feedbackTopic.id)"
            @click="toggleFeedbackTopic(feedbackTopic.id)"
          />
        </li>
      </ul>
    </LoadingWrapper>
    <template #dismiss>
      <BaseTextButton color="text" @click="emits('close')">{{
        $t('common.cancel')
      }}</BaseTextButton>
    </template>
    <template #confirm>
      <BaseTextButton color="filled" @click="saveDialogSetting">{{
        $t('common.save')
      }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>

<script setup lang="ts">
  import { computed, watch } from 'vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import BaseCheckboxListItem from '@/core/components/base/list-item/BaseCheckboxListItem.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import { useCompleteFeedbackTopics } from '@/core/composables/use-complete-feedback-topics'
  import { withoutCoachOnlyTopics } from '@/core/models/feedback-topic'
  import { useEditDialogSetting } from '@/modules/coachees/composables/use-edit-dialog-setting'

  interface Props {
    isOpen: boolean
  }

  const props = defineProps<Props>()
  const emits = defineEmits<{
    (e: 'close'): void
  }>()

  const { data: completeFeedbackTopics, status: topicsStatus } = useCompleteFeedbackTopics()
  const { selectedFeedbackTopicIds, initDialogSetting, toggleFeedbackTopic, updateDialogSetting } =
    useEditDialogSetting(() => emits('close'))

  const feedbackTopics = computed(() => completeFeedbackTopics.value?.feedbackTopics ?? [])
  const selectableFeedbackTopics = computed(() => withoutCoachOnlyTopics(feedbackTopics.value))

  const saveDialogSetting = async () => {
    const coachOnlyIds = new Set(
      feedbackTopics.value.filter((topic) => topic.coachOnly).map((topic) => topic.id),
    )
    selectedFeedbackTopicIds.value = selectedFeedbackTopicIds.value.filter(
      (id) => !coachOnlyIds.has(id),
    )
    await updateDialogSetting()
  }

  watch(
    () => props.isOpen,
    (isOpen) => {
      if (isOpen) {
        initDialogSetting()
      }
    },
  )
</script>
